import React from 'react';

/**
 * Small form building blocks shared by the workflow node config panels.
 */

/**
 * A labelled form row.
 *
 * @param {object} props
 * @param {string} props.label - The field's label.
 * @param {React.ReactNode} props.children - The field's control(s).
 */
export function Field({ label, children }) {
  return (
    <div className="wf-field">
      <label className="wf-label">{label}</label>
      {children}
    </div>
  );
}

/**
 * A warning under a field, announced to screen readers.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The warning.
 */
export function FieldAlert({ children }) {
  return (
    <div
      role="alert"
      style={{
        marginTop: 4,
        fontSize: '0.72rem',
        color: '#b45309',
        lineHeight: 1.4,
      }}
    >
      {children}
    </div>
  );
}

/**
 * A muted explanatory note under a field; renders nothing without text.
 *
 * @param {object} props
 * @param {string} [props.text] - The note.
 */
export function TypeHint({ text }) {
  if (!text) return null;
  return (
    <div
      style={{
        marginTop: 4,
        padding: '5px 8px',
        background: 'var(--hover-color)',
        border: '1px solid var(--border-color)',
        borderRadius: 4,
        fontSize: '0.73rem',
        color: 'var(--text-secondary)',
        lineHeight: 1.5,
      }}
    >
      {text}
    </div>
  );
}
